var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 93,
    viewBox: "0 0 75 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_666",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.171,
    x2: -0.104,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0151ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4db8f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7, -6)",
    filter: "url(#Ellipse_666)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_666-2",
    "data-name": "Ellipse 666",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(15.06 14.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_25",
    "data-name": "Union 25",
    d: "M7.3,13.048C5.748,12.388,0,9.125,0,9.125V4.943S5.106,7.775,7.3,8.8a4.672,4.672,0,0,0,4.587,0c.785-.4,8.923-5.228,12.64-7.436l-.748-1.3L30.221,0,26.936,5.546l-.617-1.07c-.765.463-12.515,7.583-13.919,8.372a5.668,5.668,0,0,1-2.74.658A6.1,6.1,0,0,1,7.3,13.048Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_45",
    "data-name": "Union 45",
    d: "M7.3,13.048C5.748,12.388,0,9.125,0,9.125V4.943S5.106,7.775,7.3,8.8a4.672,4.672,0,0,0,4.587,0c.785-.4,8.923-5.228,12.64-7.436l-.748-1.3L30.221,0,26.936,5.546l-.617-1.07c-.765.463-12.515,7.583-13.919,8.372a5.668,5.668,0,0,1-2.74.658A6.1,6.1,0,0,1,7.3,13.048Z",
    transform: "translate(0 14.747)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M7.3,13.048C5.748,12.388,0,9.125,0,9.125V4.943S5.106,7.775,7.3,8.8a4.672,4.672,0,0,0,4.587,0c.785-.4,8.923-5.228,12.64-7.436l-.748-1.3L30.221,0,26.936,5.546l-.617-1.07c-.765.463-12.515,7.583-13.919,8.372a5.668,5.668,0,0,1-2.74.658A6.1,6.1,0,0,1,7.3,13.048Z",
    transform: "translate(0 7.652)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractask);
export default __webpack_public_path__ + "static/media/tractask.20bfd3b02bf767db551f4278bb903277.svg";
export { ForwardRef as ReactComponent };